import { Observable } from 'rxjs';

import { modals } from '@mantine/modals';

import { FeatureFlags } from '../feature-flags/feature-flags';
import { upsInvoicedGate } from './gates/ups-invoiced-gate';
import type { GateContext, LabelPurchaseGate } from './label-purchase-gate.types';

const GATES: LabelPurchaseGate[] = [upsInvoicedGate];

export const resolveActiveGate = (ctx: GateContext): LabelPurchaseGate | null => {
  if (!new FeatureFlags({ state: ctx.state }).enableLabelPurchaseGate) {
    return null;
  }
  return GATES.find((gate) => gate.shouldApply(ctx)) ?? null;
};

// Epic entry: emits nextActionCreator() on accept; completes silently on decline.
// Mirrors showUpsTermsModalAndWait$ (store/create-label-content/create-label-content.epics.js).
export const runLabelPurchaseGate$ = ({
  state,
  fulfillmentPlanIds,
  sellerLabelProviderIds,
  nextActionCreator,
}: {
  state: unknown;
  fulfillmentPlanIds?: string[];
  sellerLabelProviderIds?: string[];
  nextActionCreator: () => unknown;
}) =>
  new Observable((observer) => {
    const gate = resolveActiveGate({ state, fulfillmentPlanIds, sellerLabelProviderIds } as GateContext);
    if (!gate) {
      observer.next(nextActionCreator());
      observer.complete();
      return;
    }
    const modalId = gate.launchModal(
      () => {
        observer.next(nextActionCreator());
        observer.complete();
      },
      () => {
        observer.next({ proceed: false });
        observer.complete();
      },
    );
    return () => modals.close(modalId);
  });
